import styled from 'styled-components';
import { themeGet } from 'modules/tetrisTheme';
export const ListItemTextContainer = styled.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: ${themeGet('spacing.xs')};
`;
